export default "__VITE_ASSET__Bbf2s1lp__"